// test652
(652 && 0);
